import { cn, Skeleton } from "@simpro/ui";
import { page } from "@/shared/styles/layout";

/**
 * The home page while the salon's profile loads (design note salon-home-landing.md section 6). It
 * holds the hero's split exactly where the loaded one puts it (design note
 * salon-booking-premium-redesign.md section 5.3 item 2), so nothing jumps when the salon arrives:
 * - on the left, the chip, three headline lines, the promise and the two buttons;
 * - on the right, the tall picture.
 */
export function HomeSkeleton() {
  return (
    <div
      aria-busy="true"
      aria-label="Loading the salon"
      className={cn(page, "grid items-center gap-10 pt-6 lg:grid-cols-12 lg:gap-12 lg:pt-10")}
    >
      <div className="flex flex-col gap-7 lg:col-span-7 lg:gap-9">
        <Skeleton className="h-8 w-56 rounded-full" />
        <div className="flex flex-col gap-3">
          <Skeleton className="h-12 w-4/5 rounded-md md:h-20 lg:h-28" />
          <Skeleton className="h-12 w-3/5 rounded-md md:h-20 lg:h-28" />
          <Skeleton className="h-12 w-2/5 rounded-md md:h-20 lg:h-28" />
        </div>
        <div className="flex w-full max-w-md flex-col gap-2">
          <Skeleton className="h-4 w-full rounded-full" />
          <Skeleton className="h-4 w-3/4 rounded-full" />
        </div>
        <div className="flex gap-3">
          <Skeleton className="h-14 flex-1 rounded-full sm:w-60 sm:flex-none" />
          <Skeleton className="h-14 w-36 rounded-full" />
        </div>
      </div>
      <Skeleton className="aspect-[4/3] w-full rounded-stack sm:aspect-[16/10] lg:col-span-5 lg:aspect-[4/5] lg:max-h-[38rem]" />
    </div>
  );
}
